import Vue from "vue"
import router from '../router'
import store from '../store'

export default {

    gql_error: (where, message)->
        if message == "User has no app_user."
            # console.log "no app_user"
            Vue.prototype.$notify.error({
                title:"Vous n'êtes plus authentifié⋅e",
                message:"Vous allez être redirigé⋅e vers la page de connexion",
                duration:3000,
                offset:100
            })
            store.commit("logout")
            setTimeout ()->
                router.push({name: 'login'})
                .catch((err)-> {})
            , 3000
            return
        Vue.prototype.$notify.error({
            title:"Une erreur graphql est survenue",
            message:where+" -> "+message,
            duration:10000,
            offset:100
        })
        return

    file_error: (title, message)->
        Vue.prototype.$notify.error({
            title:title,
            message:message,
            offset:100
        })
        return

    form_error: ()->
        Vue.prototype.$notify.error({
            title:"Formulaire",
            message:"Veuillez corriger les erreurs",
            offset:100,
            customClass:'break-word'
        })
        return

    access_denied: ()->
        Vue.prototype.$notify.error({
            title:"Accès",
            message:"Vous n'avez pas les droits nécessaires",
            offset:100,
            customClass:'break-word'
        })
        return

    access_error: (message)->
        Vue.prototype.$notify.error({
            title:"Accès",
            message:message,
            offset:100
        })
        return

    error: (where, message)->
        Vue.prototype.$notify.error({
            title:"Une erreur est survenue",
            message:where+" -> "+message,
            duration:10000,
            offset:100
        })
        return

    success: ()->
        Vue.prototype.$notify.success({
            title:"Succès",
            message:"Enregistrement effectué",
            offset:100,
            customClass:'break-word'
        })
        return

    success_message: (message)->
        Vue.prototype.$notify.success({
            title:"Succès",
            message:message,
            offset:100,
            customClass:'break-word'
        })
        return

    warning: (message)->
        Vue.prototype.$notify.warning({
            title:"Attention",
            message:message,
            duration: 10000,
            offset:100,
            customClass:'break-word'
        })
        return

    catch_error: (resp, where)->
        if resp.body?
            if resp.body.errors?
                for e in resp.body.errors
                    this.gql_error(where+": catch", e.message)
            else
                this.error(where+": catch", resp.url + ", " + resp.status)
        else
            this.error(where+": catch", resp)
}
